module.exports = __webpack_public_path__ + "static/media/WLW.f29f7ca9.png";